// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1985":"feee9e36","3240":"7964cf71","4181":"c4219a4f","4327":"d2f34edb","5065":"14f4d486","5178":"053d0201","6176":"801f31b5","6841":"a0957be0"}[chunkId] + ".css";
};